exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dashboard{color:red}.dashboard-data-container{overflow-y:scroll;height:420px!important}.dashboard-sticky-header-odd{position:sticky!important;top:0!important;background:linear-gradient(180deg,#ffe660 0,var(--primary-color))!important}.dashboard-sticky-header-even{position:sticky!important;top:0!important;background:linear-gradient(180deg,#c2c2b4 0,#cdccbc)!important}.clickable{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/dashboard/dashboard.styl
// module id = 1461
// module chunks = 0